export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "分类大全", href: "#categories" },
  { label: "收录快讯", href: "#feed" },
  { label: "资源合集", href: "#collections" },
  { label: "热门标签", href: "#tags" },
  { label: "互动广场", href: "#comments" },
];

export const heroStats = [
  { label: "收录站点", value: "1286" },
  { label: "细分分类", value: "42" },
  { label: "本周更新", value: "96" },
  { label: "累计浏览", value: "38.5万" },
];

export const heroCards = [
  {
    id: "hero-01",
    index: "01",
    title: "娱乐吃瓜",
    count: "328 站点",
    desc: "综艺、偶像、热搜里翻出来的即时线索，按事件归拢成线。",
    tags: ["热搜", "综艺", "偶像"],
  },
  {
    id: "hero-02",
    index: "02",
    title: "网红观察",
    count: "256 站点",
    desc: "直播与短视频圈层的动态脉络，时间顺序排好，方便顺藤摸瓜。",
    tags: ["直播", "短视频", "带货"],
  },
  {
    id: "hero-03",
    index: "03",
    title: "影视热议",
    count: "194 站点",
    desc: "剧集与电影的口碑拉扯，把评论、剧照与花絮聚在一处。",
    tags: ["剧集", "电影", "花絮"],
  },
  {
    id: "hero-04",
    index: "04",
    title: "网络热梗",
    count: "163 站点",
    desc: "梗的来龙去脉与源头出处，一个分类追到最早的那条。",
    tags: ["热梗", "出处", "二创"],
  },
];

export const categories = [
  {
    id: "cat-ent",
    icon: "ri-fire-line",
    name: "娱乐吃瓜",
    count: 328,
    desc: "从热搜词到完整事件线，把零散爆料串成可读的时间轴。",
    tags: ["热搜追踪", "事件整理"],
  },
  {
    id: "cat-star",
    icon: "ri-user-star-line",
    name: "网红观察",
    count: 256,
    desc: "主播与博主的动态合集，按圈层与平台分别归位。",
    tags: ["直播圈", "短视频"],
  },
  {
    id: "cat-film",
    icon: "ri-movie-2-line",
    name: "影视热议",
    count: 194,
    desc: "剧集评价、拍摄花絮与幕后讨论，适合按作品浏览。",
    tags: ["剧集", "花絮"],
  },
  {
    id: "cat-social",
    icon: "ri-newspaper-line",
    name: "社会热闻",
    count: 172,
    desc: "公共话题的讨论脉络，按时间与热度双维度排布。",
    tags: ["公共话题", "讨论"],
  },
  {
    id: "cat-sport",
    icon: "ri-basketball-line",
    name: "体育赛场",
    count: 118,
    desc: "赛事内外的话题汇总，赛季与球队两条线都能走。",
    tags: ["赛事", "球队"],
  },
  {
    id: "cat-tech",
    icon: "ri-cpu-line",
    name: "科技数码",
    count: 96,
    desc: "新品发布与数码圈议论，收录节奏跟着发布会走。",
    tags: ["新品", "数码圈"],
  },
  {
    id: "cat-life",
    icon: "ri-camera-lens-line",
    name: "生活图集",
    count: 84,
    desc: "生活记录与图集类站点，以视觉呈现为主，浏览轻快。",
    tags: ["图集", "记录"],
  },
  {
    id: "cat-game",
    icon: "ri-gamepad-line",
    name: "游戏电竞",
    count: 78,
    desc: "战队动态、版本更新与玩家社区的讨论收编。",
    tags: ["战队", "版本"],
  },
];

export const feedItems = [
  {
    id: "feed-1",
    time: "09:24",
    category: "娱乐吃瓜",
    title: "周末热搜事件收录完成，新增 12 个可用站点",
    summary: "按事件起点、发酵节点、二次讨论三段整理，目录已同步到分类页。",
    heat: "1.2万",
  },
  {
    id: "feed-2",
    time: "昨天 21:40",
    category: "网红观察",
    title: "直播圈分类补充 6 个合集，补齐早期时间线",
    summary: "这次重点是把时间最早的几条线索找回来，方便顺着往前翻。",
    heat: "8400",
  },
  {
    id: "feed-3",
    time: "昨天 15:02",
    category: "影视热议",
    title: "新剧口碑讨论合集上线，收录剧评与花絮",
    summary: "把剧评、拍摄花絮和观众短评分成三摞，按需进入。",
    heat: "6100",
  },
  {
    id: "feed-4",
    time: "09.09 11:18",
    category: "网络热梗",
    title: "两个热梗补上源头出处，标注最早传播路径",
    summary: "梗的出生地找到了，顺便把二创合集一起收进来。",
    heat: "5300",
  },
  {
    id: "feed-5",
    time: "09.08 19:45",
    category: "社会热闻",
    title: "公共话题分类调整排序，按讨论热度重排",
    summary: "排序规则从时间优先改为热度优先，浏览时更容易抓到重点。",
    heat: "4200",
  },
  {
    id: "feed-6",
    time: "09.07 08:30",
    category: "科技数码",
    title: "数码圈新增发布季专题，跟随发布会节奏更新",
    summary: "每逢新品季自动加更，专题页把参数讨论与实测合集并排放。",
    heat: "3600",
  },
];

export const collections = [
  {
    id: "col-1",
    title: "本周吃瓜速览合集",
    desc: "把这一周分散在各处的线索按时间顺序排成一条线，看一遍就懂来龙去脉。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20collage%20with%20warm%20cream%20paper%20textures%2C%20layered%20torn%20paper%20shapes%2C%20soft%20grain%2C%20muted%20terracotta%20and%20brick%20red%20tones%2C%20minimalist%20art%20direction%2C%20no%20text%2C%20no%20people%2C%20soft%20natural%20light&width=720&height=480&seq=heila-collection-cover-01&orientation=landscape",
    meta: "收录 46 站 · 更新于本周",
    tags: ["时间线", "本周"],
  },
  {
    id: "col-2",
    title: "分类检索入门合集",
    desc: "第一次来不知道怎么逛，从这份合集出发，跟着分类一层层往下走就好。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20design%20with%20sage%20green%20and%20warm%20beige%20paper%20cut%20layers%2C%20stacked%20index%20cards%20arrangement%2C%20subtle%20texture%2C%20calm%20muted%20palette%2C%20minimal%20composition%2C%20no%20text%2C%20no%20people%2C%20soft%20even%20lighting&width=720&height=480&seq=heila-collection-cover-02&orientation=landscape",
    meta: "收录 32 站 · 新手推荐",
    tags: ["入门", "检索"],
  },
  {
    id: "col-3",
    title: "深夜图集慢逛合集",
    desc: "偏视觉向的站点集中在这里，配图克制、目录干净，适合慢慢翻。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20with%20golden%20amber%20spotlight%20beams%20falling%20on%20textured%20paper%20and%20soft%20fabric%20folds%2C%20warm%20shadow%20gradients%2C%20muted%20earthy%20palette%2C%20minimal%20art%20direction%2C%20no%20text%2C%20no%20people&width=720&height=480&seq=heila-collection-cover-03&orientation=landscape",
    meta: "收录 28 站 · 视觉向",
    tags: ["图集", "慢逛"],
  },
];

export const hotTags = [
  { name: "热搜事件", level: 3 },
  { name: "直播圈", level: 2 },
  { name: "剧集花絮", level: 2 },
  { name: "热梗出处", level: 3 },
  { name: "图集记录", level: 1 },
  { name: "赛事动态", level: 2 },
  { name: "数码新品", level: 1 },
  { name: "游戏版本", level: 1 },
  { name: "公共话题", level: 2 },
  { name: "二创合集", level: 1 },
  { name: "新人入门", level: 2 },
  { name: "深夜慢逛", level: 1 },
];

export const comments = [
  {
    id: "c-1",
    initial: "瓜",
    name: "蹲点小分队",
    time: "8 分钟前",
    content: "分类做得挺清楚，按时间线走一遍基本能把来龙去脉串起来，比自己在搜索里翻省事多了。",
    likes: 128,
    replies: [
      {
        id: "c-1-r1",
        initial: "夜",
        name: "夜巡编辑",
        time: "5 分钟前",
        content: "谢谢反馈，这周会把时间线的节点标注再补细一些。",
      },
    ],
  },
  {
    id: "c-2",
    initial: "阿",
    name: "阿茶不喝茶",
    time: "27 分钟前",
    content: "建议合集里再分一个「只看源头」的入口，有时候就想直接看最早那条。",
    likes: 76,
    replies: [],
  },
  {
    id: "c-3",
    initial: "M",
    name: "Moonlit_07",
    time: "1 小时前",
    content: "留白看着真舒服，没有堆一堆东西，慢慢翻不累眼，这个节奏我喜欢。",
    likes: 54,
    replies: [
      {
        id: "c-3-r1",
        initial: "编",
        name: "目录小编",
        time: "52 分钟前",
        content: "收到，接下来也会保持疏一点的排布。",
      },
      {
        id: "c-3-r2",
        initial: "小",
        name: "小满",
        time: "40 分钟前",
        content: "同感，标题优先这点很加分。",
      },
    ],
  },
  {
    id: "c-4",
    initial: "北",
    name: "北纬三十度",
    time: "3 小时前",
    content: "标签云挺好用，点进去就能找到对应分类，希望热门标签能一直跟着更新。",
    likes: 31,
    replies: [],
  },
];

export const collectionStandards = [
  "站点内容需有稳定的更新节奏，长期停更会进入观察名单。",
  "主题需能归入现有分类，或具备独立成一个新分类的价值。",
  "页面浏览体验良好，广告与弹窗不过度干扰阅读。",
  "目录结构清晰，能让人快速判断内容方向与更新状态。",
  "提交时请附上站点介绍与所属分类，便于我们快速归档。",
];

export const footerGroups = [
  {
    title: "热门分类",
    links: [
      { label: "娱乐吃瓜", href: "#categories" },
      { label: "网红观察", href: "#categories" },
      { label: "影视热议", href: "#categories" },
      { label: "网络热梗", href: "#categories" },
    ],
  },
  {
    title: "快速到达",
    links: [
      { label: "收录快讯", href: "#feed" },
      { label: "资源合集", href: "#collections" },
      { label: "热门标签", href: "#tags" },
      { label: "互动广场", href: "#comments" },
    ],
  },
  {
    title: "关于导航",
    links: [
      { label: "收录标准", href: "#submit" },
      { label: "更新说明", href: "#feed" },
      { label: "浏览提示", href: "#top" },
      { label: "返回顶部", href: "#top" },
    ],
  },
];